import React from "react";
import { useNavigate } from 'react-router-dom';
import SocialIcon from "./SocialIcon";

const FooterSection = () => {
  const navigate = useNavigate();

  const shopCategories = [
    { name: "What's New", filterValue: "New Arrivals" },
    { name: "Sarees", filterValue: "Sarees" },
    { name: "Salwar Kameez", filterValue: "Salwar Kameez" },
    { name: "Lehengas", filterValue: "Lehengas" },
    { name: "Men's Wear", filterValue: "Men" }
  ];

  const handleCategoryClick = (category) => {
    // Navigate to products page with category parameter
    const searchParams = new URLSearchParams();

    if (category.filterValue) {
      searchParams.set('category', category.filterValue);
    }

    navigate(`/products?${searchParams.toString()}`);
  };

  const handleUsefulLinkClick = (link) => {
    // Handle navigation for useful links
    switch(link) {
      case 'Cancellation & Refund Policy':
        navigate('/Cancellation');
        break;
      case 'Contact Us':
        navigate('/contact');
        break;
      case 'FAQ\'s':
        navigate('/faq');
        break;
      case 'Terms of Use':
        navigate('/terms');
        break;
      case 'Privacy & Policies':
        navigate('/privacy');
        break;
      default:
        // For now, just navigate to home for unhandled links
        navigate('/');
    }
  };

  const handleServiceClick = (service) => {
    // Handle navigation for service links
    switch(service) {
      case 'Store Locator':
        navigate('/store-locator');
        break;
      case 'Track Order':
        navigate('/track-order');
        break;
      case 'Cash on Delivery':
      case 'Shipping Policy':
        navigate('/shipping-info');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <footer className="bg-[#4C5A53] bg-opacity-90 text-white w-full">
      {/* Brand Section */}
      <div className="flex flex-col md:flex-row justify-between items-center px-8 py-6 border-b border-white/20 max-sm:px-5">
        <div className="flex items-center gap-3">
          <img
            src={"https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/602ab5c89aae71bf9fd0b889c5d6d9fdf098545c?placeholderIfAbsent=true"}
            alt="ONE-STEP Logo"
            className="w-12 h-12 rounded-full object-cover"
          />
          <h2 className="text-2xl font-semibold tracking-wide">ONE-STOP WEDDING DRESSES</h2>
        </div>
        <div className="flex gap-4 mt-4 md:mt-0">
          <SocialIcon type="facebook" />
          <SocialIcon type="twitter" />
          <SocialIcon type="instagram" />
        </div>
      </div>

      {/* Links Section */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 px-8 py-10 max-sm:px-5 max-sm:py-8">
        {/* Shop Now */}
        <div>
          <h3 className="text-lg font-medium mb-4">Shop Now</h3>
          <ul className="space-y-3 text-sm font-light">
            {shopCategories.map((category, index) => (
              <li key={index}>
                <button
                  onClick={() => handleCategoryClick(category)}
                  className="hover:text-gray-300 text-left transition-colors focus:outline-none focus:text-gray-300"
                  aria-label={`Shop ${category.name} products`}
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Useful Links */}
        <div>
          <h3 className="text-lg font-medium mb-4">Useful Links</h3>
          <ul className="space-y-3 text-sm font-light">
            {['Cancellation & Refund Policy', 'Contact Us', 'Terms of Use', 'Privacy & Policies'].map((link, index) => (
              <li key={index}>
                <button
                  onClick={() => handleUsefulLinkClick(link)}
                  className="hover:text-gray-300 text-left transition-colors focus:outline-none focus:text-gray-300"
                  aria-label={`Navigate to ${link}`}
                >
                  {link}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-lg font-medium mb-4">Services</h3>
          <ul className="space-y-3 text-sm font-light">
            {['Shipping Policy'].map((service, index) => (
              <li key={index}>
                <button
                  onClick={() => handleServiceClick(service)}
                  className="hover:text-gray-300 text-left transition-colors focus:outline-none focus:text-gray-300"
                  aria-label={`Navigate to ${service}`}
                >
                  {service}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-medium mb-4">Contact Us</h3>
          <address className="not-italic space-y-2 text-sm font-light">
            <p>ONE-STOP</p>
            <p>Andhra Pradesh,
Vizianagaram district,
Padalapeta village, Pincode:535006</p>
            <p>0091-8041113330 (STORE)</p>
            <p>24x7 Live Chat</p>
            <p>onestopweddingdresses@gmail.com</p>
            <p>+91-8333922444</p>
            <p>(Mon–Sat: 11AM–7PM)</p>
          </address>
        </div>
      </div>

      {/* Bottom Bar */}
       <div className="border-t border-white/20 py-4 text-center text-sm font-light">
        © 2025 ONE-STOP WEDDING DRESSES . All Rights Reserved  | Designed & Developed by <a target="_blank" href="https://www.vikrin.com/">Vikrin.</a>
      </div>
    </footer>
  );
};

export default FooterSection;
